import { Container } from '@sainsburys-tech/luna-grid'
import { Button } from '@sainsburys-tech/luna-button'
import { clearSessionData } from '../../utils/clearSessionData';
interface ReportIncidentProps {
  onClick: () => void;
}

const ReportIncident = ({ onClick }: ReportIncidentProps) => {
  
  const handleOnClick = () => {
    clearSessionData()
    if (sessionStorage.getItem('draftId')) {
      sessionStorage.removeItem('draftId')
    }
    onClick()
  }

  return (
    <Container className="ln-u-padding-ends*3" size="xs">
      <Button
        id="s-report-safety-accident"
        className="ln-u-bg-color-white report-accident-button report-accident-button-mobile"
        variant="outlined"
        disabled={false}
        element="button"
        onClick={handleOnClick}
        >
        Report a security incident
      </Button>
    </Container>
  );
};

export default ReportIncident;